import React, { useState } from "react";
import { X, Save } from "lucide-react";

const CommitDialog = ({ isOpen, onClose, onCommit, fileName }) => {
  const [message, setMessage] = useState(`Update ${fileName}`);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onCommit(message);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop with blur */}
      <div className="fixed inset-0 bg-black/30 backdrop-blur-[2px]" />

      {/* Modal container */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-slate-100 dark:bg-neutral-900 rounded-2xl shadow-2xl w-full max-w-2xl mx-auto overflow-hidden transform transition-all">
          {/* Subtle gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" />

          {/* Header with subtle background */}
          <div className="relative flex items-center justify-between px-6 py-3 bg-slate-200 dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-800">
            <h2 className="text-base font-semibold text-neutral-900 dark:text-white">
              Commit Changes
            </h2>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-slate-300 dark:hover:bg-neutral-700 transition-colors"
            >
              <X size={20} className="text-neutral-500 dark:text-neutral-400" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="relative p-6">
            <div className="space-y-5">
              {/* Description */}
              <p className="text-sm text-neutral-600 dark:text-neutral-300">
                Enter a commit message for your changes to{" "}
                <span className="font-medium">{fileName}</span>:
              </p>

              {/* Commit Message Textarea */}
              <div>
                <label
                  className="block mb-2 text-sm font-medium text-neutral-700 dark:text-neutral-300"
                  htmlFor="commitMessage"
                >
                  Commit Message
                </label>
                <textarea
                  id="commitMessage"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Describe your changes..."
                  className="w-full px-4 py-3 bg-slate-50 dark:bg-neutral-800 border border-slate-300 dark:border-neutral-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-action focus:border-transparent transition-all text-neutral-900 dark:text-white placeholder-neutral-500 resize-none"
                  rows={4}
                  autoFocus
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-3 mt-8">
              <button
                type="button"
                className="px-4 py-2 text-sm text-slate-600 dark:text-neutral-300 bg-slate-300 dark:bg-neutral-700 hover:bg-slate-400 dark:hover:bg-neutral-600 rounded-xl font-medium transition-all"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm bg-brand-action hover:bg-brand-action-hover text-brand-action-text rounded-xl font-medium transition-all flex items-center disabled:opacity-50 disabled:bg-slate-300 dark:disabled:bg-neutral-600 disabled:text-slate-500 dark:disabled:text-neutral-400 shadow-sm"
                disabled={!message.trim()}
              >
                <Save size={16} className="mr-2" />
                Commit & Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CommitDialog;
